import BUNDLE_PROTECTIONPLAN_ON_CHANGE from '../actionTypes/BundleProtectionPlanActionTypes';

function BundleProtectionPlanReducer(state = {}, action) {
    switch (action.type) {
        case BUNDLE_PROTECTIONPLAN_ON_CHANGE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

BundleProtectionPlanReducer.reducerName = 'bundleProtectionPlan';
export default BundleProtectionPlanReducer;
